module.exports = __webpack_public_path__ + "static/media/journeymap.36df7a20.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd552/journeymap.JPG
// module id = 60
// module chunks = 0